import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  ModalController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonTitle,
  IonToolbar,
} from "@ionic/angular/standalone";

@Component({
  selector: "app-relogin-modal",
  template: `
    <ion-header>
      <ion-toolbar>
        <ion-title>Session expired</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="dismiss()">Cancel</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content data-testid="relogin-modal">
      <p class="ion-padding-horizontal">Sign in again as {{ username }} to continue.</p>
      <ion-item>
        <ion-input
          data-testid="relogin-username"
          [value]="username"
          [readonly]="true"
          label="Username"
          labelPlacement="floating"
        ></ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          data-testid="relogin-password"
          [(ngModel)]="password"
          label="Password"
          labelPlacement="floating"
          type="password"
        ></ion-input>
      </ion-item>
      <ion-button
        expand="block"
        (click)="submit()"
        data-testid="relogin-submit"
      >Sign in again</ion-button>
      <ion-button expand="block" fill="clear" (click)="switchAccount()"
        data-testid="relogin-switch-account">Sign in with another account</ion-button>
      <p class="ion-padding-horizontal">Unsent data will stay saved for this account.</p>
    </ion-content>
  `,
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonItem,
    IonInput,
    FormsModule,
  ],
})
export class ReLoginModalComponent {
  private modalCtrl = inject(ModalController);

  username: string;
  password: string;

  constructor() {}

  dismiss() {
    this.modalCtrl.dismiss(null);
  }

  switchAccount() {
    this.modalCtrl.dismiss(null, "switch-account");
  }

  submit() {
    this.modalCtrl.dismiss({
      username: this.username,
      password: this.password,
    });
  }
}
